import React from 'react';
export default class MinimalResumeSummary extends React.Component{
    render(){
        return  <div data-v-b8233322="" className="section">
                    <div data-v-b8233322="" className="section-headline">{this.props.title}</div>
                    <div data-v-b8233322="" className="section-description" dangerouslySetInnerHTML={{ __html: this.props.data.description }}></div>
                </div>
    }
}